import { InputHTMLAttributes } from "react";
import { ValueOf } from "utils/typeCheck.utils";

export const INPUT_VARIANT = {
  GHOST: "ghost", // without border
} as const;

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: ValueOf<typeof INPUT_VARIANT>;
  label?: string;
  inputClassName?: string;
  error?: boolean;
  errorMessage?: string;
  wrapperClassName?: string;
}
